/**************************************
 * datestring checkers
 *************************************/

/** Use this if you want to check without throwing an error if false. */
const isDatestring = (thing, allowNull = true) => {
  if (allowNull && (thing === null || thing === undefined)) {
    return true
  }
  return typeof thing === 'string' && /\d{4}-\d{2}-\d{2}/.test(thing)
}

/**************************************
 * timestring checkers
 *************************************/

const timestringError = 'Must be a string in iso format with a timestamp and explicitly in UTC.'

/** Use this if you want to check without throwing an error if false. */
export const isTimestring = (thing, allowNull = true) => {
  if (allowNull && (thing === null || thing === undefined)) {
    return true
  }
  return (
    typeof thing === 'string' &&
    /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(\.[0-9]+)?([zZ]|[+-]00:00)/.test(thing)
  )
}

/** Use this if you want to throw an error if it doesn't check out. */
export const checkTimestring = (thing, allowNull = true) => {
  if (!isTimestring(thing, allowNull)) {
    throw new Error(timestringError)
  }
}

/**************************************
 * timeordate checkers
 *************************************/

const timeordateError =
  'Must be an iso string, either without timestamp (timezone implied by context) or with timestamp explicitly in UTC.'

/** Use this if you want to check without throwing an error if false. */
export const isTimeordate = (thing, allowNull = true) =>
  isTimestring(thing, allowNull) || isDatestring(thing, allowNull)

/** Use this if you want to throw an error if it doesn't check out. */
export const checkTimeordate = (thing, allowNull = true) => {
  if (!isTimeordate(thing, allowNull)) {
    throw new Error(timeordateError)
  }
}
